import { format } from 'date-fns'
import { INewPartnerCostFormValues } from 'features/PartnerCost/types'
import { PartnerCostScheduleDow, UpsertPartnerCostsInput } from 'gql/generated/graphql'
import { GTCompanyV2Vertical } from 'gql/types.generated'
import { getWeekday, US_DATE_FORMAT } from 'utils/date'
import { sanitizePrice } from 'utils/math'

export const mapFormValuesToUpsertPartnerCostsInput = (
  values: INewPartnerCostFormValues,
  vehicleCapacity: number
): UpsertPartnerCostsInput => {
  const baseCost = values.baseCosts.find(({ capacity }) => capacity === vehicleCapacity)
  const vehicles = values.partnerVehicles.filter(({ capacity }) => capacity === vehicleCapacity)
  return {
    routeServiceIDs: values.routeServices.map(({ id }) => id),
    vehicleIDs: vehicles.map(({ id }) => id),
    schedule: {
      startAt: format(values.startDate, US_DATE_FORMAT),
      endAt: values.endDate ? format(values.endDate, US_DATE_FORMAT) : undefined,
      dow: values.operationDays.map((day) => getWeekday(day) as unknown as PartnerCostScheduleDow),
      cost: sanitizePrice((baseCost?.amount as number) * 100, true),
      note: values.note
    }
  }
}

export const PARTNER_COST_VERTICALS = [GTCompanyV2Vertical.City, GTCompanyV2Vertical.Team, GTCompanyV2Vertical.Rental]
